module.exports = __webpack_public_path__ + "static/img/fuselage_703K.8bbdd1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/fuselage_703K.jpg
// module id = 2Jpy
// module chunks = 0